// GetInvolvedToday.js
import React, { useState } from 'react';
import './get-involved-today.css';
import { Link } from 'react-router-dom';
import emailjs from 'emailjs-com';
import { FaHandsHelping, FaHeart, FaHandshake, FaBullhorn } from "react-icons/fa";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";



function GetInvolvedToday() {
  const [activeTab, setActiveTab] = useState('volunteer');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    interest: 'volunteer',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

const handleSubmit = (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  const serviceID = 'service_3ll0pai';
  const templateID = 'template_feitzmp';
  const userID = '4qRMFMVMforJccgUz';

  emailjs.send(serviceID, templateID, formData, userID)
    .then((response) => {
      console.log('Email sent successfully', response.status, response.text);
      setIsSubmitting(false);
      setIsSubmitted(true);

      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        interest: 'volunteer',
        message: ''
      });

      // Hide success message after 5s
      setTimeout(() => setIsSubmitted(false), 5000);
    })
    .catch((error) => {
      console.error('Failed to send email:', error);
      setIsSubmitting(false);
      alert('Oops! Something went wrong. Please try again.');
    });
};

  return (
    <div className="get-involved-page">
      {/* Hero Section */}
      <section className="involved-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Get Involved Today</h1>
          <p>Join us in our mission to provide quality eye care to every Sri Lankan</p>
        </div>
      </section>

      {/* Introduction */}
      <section className="intro-section">
        <div className="container">
          <h2>Together We Can Make a Difference</h2>
          <p>
            Your support can help us reach more people, provide better care, and create lasting change 
            in our community. Whether you have a few hours or want to make a long-term commitment, 
            there's a place for you at Lions Club of Colombo Eye Care.
          </p>
        </div>
      </section>

      {/* Ways to Get Involved */}
     <section className="ways-section">
      <div className="container">
        <h2 className="section-title">
          Ways to <span>Get Involved</span>
        </h2>

        <div className="ways-grid">
          <div className="way-card" onClick={() => setActiveTab("volunteer")}>
            <div className="card-icon">
              <FaHandsHelping />
            </div>
            <h3>Volunteer</h3>
            <p>
              Give your time and skills to help at events, screenings, and community programs
            </p>
          </div>

          <div className="way-card" onClick={() => setActiveTab("donate")}>
            <div className="card-icon">
              <FaHeart />
            </div>
            <h3>Donate</h3>
            <p>
              Support our programs financially or donate equipment and supplies
            </p>
          </div>

          <div className="way-card" onClick={() => setActiveTab("partner")}>
            <div className="card-icon">
              <FaHandshake />
            </div>
            <h3>Partner With Us</h3>
            <p>
              Corporate partnerships, sponsorships, and community collaborations
            </p>
          </div>

          <div className="way-card" onClick={() => setActiveTab("advocate")}>
            <div className="card-icon">
              <FaBullhorn />
            </div>
            <h3>Advocate</h3>
            <p>
              Spread awareness about eye health and our mission in your community
            </p>
          </div>
        </div>
      </div>
    </section>





      {/* Tab Content */}
      <section className="tab-content-section">
        <div className="container">
          {activeTab === 'volunteer' && (
            <div className="tab-panel active">
              <div className="tab-header">
                <h3>Volunteer Opportunities</h3>
                <p>Choose how you'd like to contribute your time and talents</p>
              </div>
              
              <div className="opportunities-grid">
                <div className="opportunity-card">
                  <span className="badge">Flexible Hours</span>
                  <h4>Event Support</h4>
                  <p>Help organize and run eye screening camps and community events</p>
                  <ul>
                    <li>✓ Registration desk</li>
                    <li>✓ Patient guidance</li>
                    <li>✓ Setup and cleanup</li>
                  </ul>
                </div>

                <div className="opportunity-card">
                  <span className="badge">Weekly</span>
                  <h4>Administrative Support</h4>
                  <p>Assist with office work, data entry, and coordination</p>
                  <ul>
                    <li>✓ Phone calls</li>
                    <li>✓ Record keeping</li>
                    <li>✓ Scheduling</li>
                  </ul>
                </div>

                <div className="opportunity-card">
                  <span className="badge">Monthly</span>
                  <h4>Medical Volunteers</h4>
                  <p>Healthcare professionals supporting our clinical work</p>
                  <ul>
                    <li>✓ Vision screening</li>
                    <li>✓ Health education</li>
                    <li>✓ Basic assessments</li>
                  </ul>
                </div>

                <div className="opportunity-card">
                  <span className="badge">Special Events</span>
                  <h4>Photography & Media</h4>
                  <p>Document our events and help share our story</p>
                  <ul>
                    <li>✓ Event photography</li>
                    <li>✓ Social media</li>
                    <li>✓ Content creation</li>
                  </ul>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'donate' && (
            <div className="tab-panel active">
              <div className="tab-header">
                <h3>Make a Donation</h3>
                <p>Your generosity helps us provide free eye care to those in need</p>
              </div>

              <div className="donation-options">
                <div className="donation-card">
                  {/* <div className="amount">LKR 1,000</div> */}
                  <p>For eye screening</p>
                  {/* <button className="donate-btn">Donate Now</button> */}
                </div>

                <div className="donation-card featured">
                  <div className="popular-badge">Most Popular</div>
                  {/* <div className="amount">LKR 5,000</div> */}
                  <p>Provides glasses for 2 patients</p>
                  {/* <button className="donate-btn">Donate Now</button> */}
                </div>

                <div className="donation-card">
                  {/* <div className="amount">LKR 10,000</div> */}
                  <p>Supports one cataract surgery</p>
                  {/* <button className="donate-btn">Donate Now</button> */}
                </div>
              </div>

<div className="equipment-donation">
  <h4>Equipment & Supplies Donation</h4>
  <p>We also accept medical equipment, eyewear, and supplies</p>

  <Link to="/contactus">
    <button className="contact-btn">
      Contact Us About Donations
    </button>
  </Link>
</div>
            </div>
          )}

          {activeTab === 'partner' && (
            <div className="tab-panel active">
              <div className="tab-header">
                <h3>Partnership Opportunities</h3>
                <p>Let's work together to create lasting impact</p>
              </div>

              <div className="partnership-grid">
                <div className="partnership-card">
                  <h4>Corporate Sponsorship</h4>
                  <p>Sponsor events, programs, or our mobile clinic</p>
                  <ul>
                    <li>✓ Brand visibility</li>
                    <li>✓ CSR opportunities</li>
                    <li>✓ Employee engagement</li>
                  </ul>
                </div>

                <div className="partnership-card">
                  <h4>Community Partners</h4>
                  <p>Collaborate on outreach programs and events</p>
                  <ul>
                    <li>✓ Shared resources</li>
                    <li>✓ Joint events</li>
                    <li>✓ Network expansion</li>
                  </ul>
                </div>

                <div className="partnership-card">
                  <h4>Medical Partners</h4>
                  <p>Healthcare organizations supporting our clinical work</p>
                  <ul>
                    <li>✓ Referral network</li>
                    <li>✓ Professional collaboration</li>
                    <li>✓ Knowledge sharing</li>
                  </ul>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'advocate' && (
            <div className="tab-panel active">
              <div className="tab-header">
                <h3>Become an Advocate</h3>
                <p>Help us raise awareness about eye health in your community</p>
              </div>

              <div className="advocacy-grid">
                <div className="advocacy-card">
                  <div className="icon">📢</div>
                  <h4>Spread the Word</h4>
                  <p>Share our mission on social media and with friends & family</p>
                </div>

                <div className="advocacy-card">
                  <div className="icon">🏫</div>
                  <h4>Community Talks</h4>
                  <p>Organize or host eye health awareness sessions</p>
                </div>

                <div className="advocacy-card">
                  <div className="icon">📝</div>
                  <h4>Fundraising</h4>
                  <p>Create your own fundraising campaign</p>
                </div>

                <div className="advocacy-card">
                  <div className="icon">🤝</div>
                  <h4>Ambassador Program</h4>
                  <p>Became a long-term advocate for our cause</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Sign Up Form */}
      <section className="form-section">
        <div className="container">
          <div className="form-container">
            <h3>Ready to Get Started?</h3>
            <p>Fill out the form below and we'll contact you with next steps</p>

            {isSubmitted ? (
              <div className="success-message">
                ✓ Thank you for your interest! We'll be in touch soon.
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="involvement-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      placeholder="Your full name"
                    />
                  </div>
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      placeholder="your@email.com"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="+94 XX XXX XXXX"
                    />
                  </div>
                  <div className="form-group">
                    <label>I'm interested in *</label>
                    <select
                      name="interest"
                      value={formData.interest}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="volunteer">Volunteering</option>
                      <option value="donate">Donating</option>
                      <option value="partner">Partnership</option>
                      <option value="advocate">Advocacy</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>Message (Optional)</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="4"
                    placeholder="Tell us how you'd like to help or ask any questions..."
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>





      {/* Contact Info */}
       <section className="contact-info-section">
      <div className="container">
        <div className="contact-cards">
          <div className="contact-card">
            <div className="icon">
              <FaPhoneAlt />
            </div>
            <h4>Call Us</h4>
            <p>+94 77 344 0937</p>
            <small>Mon-Fri, 9am-5pm</small>
          </div>

          <div className="contact-card">
            <div className="icon">
              <FaEnvelope />
            </div>
            <h4>Email</h4>
            <p>volunteer@colomboeyecare.lk</p>
            <small>We reply within 24hrs</small>
          </div>

          <div className="contact-card">
            <div className="icon">
              <FaMapMarkerAlt />
            </div>
            <h4>Visit Us</h4>
            <p>932, Galle Road, Colombo 03</p>
            <small>By appointment</small>
          </div>
        </div>
      </div>
    </section>
    </div>
  );
}

export default GetInvolvedToday;